import React, { FunctionComponent } from 'react';

const IntegrationsIcon: FunctionComponent<React.PropsWithChildren<{ color?: string }>> = ({
  color
}) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill={color} xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.3333 10.6667L8.66667 8V5.88C9.44 5.6 10 4.86667 10 4C10 2.89333 9.10667 2 8 2C6.89333 2 6 2.89333 6 4C6 4.86667 6.56 5.6 7.33333 5.88V8L4.66667 10.6667H2V14H5.33333V11.9667L8 9.16667L10.6667 11.9667V14H14V10.6667H11.3333Z"
    />
  </svg>
);

export default IntegrationsIcon;
